import React from 'react';

const LoadingSpinner: React.FC = () => (
  <div className="space-y-3" role="status" aria-live="polite" aria-label="Loading jobs">
    {[0, 1, 2].map(item => <div key={item} className="animate-pulse rounded-2xl border border-[#A1AAD9]/25 bg-white p-5"><div className="flex items-start gap-4"><span className="h-10 w-10 flex-none rounded-xl bg-[#FFF5D7]" /><div className="min-w-0 flex-1"><span className="block h-3 w-24 rounded-full bg-[#A1AAD9]/25" /><span className="mt-3 block h-4 w-2/3 rounded-full bg-[#A1AAD9]/20" /><span className="mt-4 block h-3 w-1/2 rounded-full bg-[#A1AAD9]/15" /></div></div></div>)}
    <span className="sr-only">Loading available jobs</span>
  </div>
);

export default LoadingSpinner;
